// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bf37b5bf","703":"f1583fc0"}[chunkId] + ".chunk.js";
};